import classNames from 'classnames/bind';
import React from 'react';
import PropTypes from 'prop-types';
import { deckeeFullLogo, ReactSvg } from '../../shared/vector-images';
import Text from '../../shared/_deprecated/elements/Text/Text';
import styles from './AppOffline.scss';

const cx = classNames.bind(styles);

const appOfflineMessage = window?.DECKEE_CONFIG?.appOfflineMessage;

const AppOffline = ({ className }) => {
  const viewClasses = cx('app-offline', {
    [className]: className,
  });

  return (
    <div className={viewClasses}>
      <div className={cx('app-offline__content')}>
        <ReactSvg
          className={cx('app-offline__logo')}
          toDisplay={deckeeFullLogo()}
          options={{
            fillColor: '#FF5C39',
          }}
          width={180}
          height={57}
        />

        {appOfflineMessage?.title && (
          <Text
            className={cx('app-offline__title')}
            size="4"
            align="center"
            type="light"
            strong
          >
            {appOfflineMessage.title}
          </Text>
        )}

        {appOfflineMessage?.content && (
          <Text
            className={cx('app-offline__message')}
            size="1"
            align="center"
            type="light"
          >
            {appOfflineMessage.content.map((messageBlock) => (
              <p>{messageBlock}</p>
            ))}
          </Text>
        )}
      </div>
    </div>
  );
};

AppOffline.propTypes = {
  /** Extra classes */
  className: PropTypes.string,
};

AppOffline.defaultProps = {
  className: null,
};

export default AppOffline;
